import React from 'react'
import PropTypes from 'prop-types'
import Step from '../../../components/Step'
import Select from 'react-select'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import EditPrescriberView from './EditPrescriberView'
import './SiteTools.scss'

const SITE = 'Site'
const SALES_PERSON = 'SalesPerson'

const PRESCRIBER = 'Prescriber'

const SALES_PEOPLE = [
  {
    id: 385,
    email: 'jake@athelas.com',
  },
  {
    id: 386,
    email: 'evie@athelas.com',
  },
  {
    id: 387,
    email: 'vishnu@athelas.com',
  },
  {
    id: 388,
    email: 'rachel@athelas.com',
  },
  {
    id: 'null',
    email: 'None',
  }
]

const INITIAL_STATE = {
  [`selected${SITE}`]: null,
  [`selected${PRESCRIBER}`]: null,
  [`selected${SALES_PERSON}`]: null,
  [`input${SITE}`]: '',
  [`input${PRESCRIBER}`]: '',
  [`input${SALES_PERSON}`]: '',
}

export default class PrescriberVerificationView extends React.Component {
  static propTypes = {
    isFetchingSites: PropTypes.bool,
    isFetchingPrescribers: PropTypes.bool,
    isUploadingSignature: PropTypes.bool,
    isUpdatingPrescriber: PropTypes.bool,
    sites: PROPTYPES.sites,
    updatePrescriber: PropTypes.func,
    prescribers: PROPTYPES.prescribers,
    getPrescriber: PropTypes.func,
    getPrescribers: PropTypes.func,
  }

  static defaultProps = {
    isFetchingSites: false,
    isFetchingPrescribers: false,
    isUploadingSignature: false,
    isUpdatingPrescriber: false,
    sites: [],
    prescribers: [],
    getPrescriber: _.noop,
    getPrescribers: _.noop,
  }

  constructor (props) {
    super(props)
    this.state = INITIAL_STATE
  }

  handleSelect = (resourceType, selected) => {
    const { getPrescriber, getPrescribers } = this.props
    if (selected == null) {
      selected = ''
    }
    this.setState({ [`selected${resourceType}`]: selected })
    if (resourceType === SITE) {
      getPrescribers(null, selected.id, true)
    }
    if (resourceType === SALES_PERSON) {
      getPrescribers(selected.id, null, true)
    }
    if (resourceType === PRESCRIBER) {
      getPrescriber(selected.id, true)
    }
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  resetFilter = () => {
    const { getPrescribers } = this.props
    this.setState(INITIAL_STATE)
    getPrescribers()
  }

  render () {
    const {
      updatePrescriber,
      isFetchingSites,
      isFetchingPrescribers,
      sites,
      prescribers,
      isUploadingSignature,
      isUpdatingPrescriber,
    } = this.props
    const {
      selectedSite,
      selectedPrescriber,
      selectedSalesPerson,
    } = this.state
    return (
      <div className='step-form'>
        <div>
          <div className='alert alert-warning text-center'>
            If you don't have an NPI number, please <a href='https://www.hipaaspace.com/medical_billing/coding/national_provider_identifier/npi_number_lookup.aspx' target='_new'>look it up here</a>.
          </div>
          <Step
            title='Select a filter'
            isCollapsed={!!selectedSite || !!selectedPrescriber || !!selectedSalesPerson}
          >
            {
              selectedSite || selectedPrescriber || selectedSalesPerson
              ? <div>
                <span className='padded-right'>
                  { selectedSite ? `${SITE}: ` : ''}
                  { selectedPrescriber ? `${PRESCRIBER}: ` : ''}
                  { selectedSalesPerson ? `Sales Person: ` : ''}
                  { (selectedSite && selectedSite.name) || (selectedPrescriber && selectedPrescriber.name) || (selectedSalesPerson && selectedSalesPerson.email) || ''}
                </span>
                <button
                  className='btn btn-primary update-button'
                  onClick={this.resetFilter}
                  disabled={isFetchingPrescribers}
                >
                  Reset
                </button>
              </div>
              : <div>
                <div>Site</div>
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingSites}
                  options={sites}
                  value={selectedSite}
                  onChange={(selected) => this.handleSelect(SITE, selected)}
                  onInputChange={(input) => this.handleInput(SITE, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'name'}
                  valueKey={'id'}
                />
                <div>Sales Person</div>
                <Select
                  isSearchable
                  isClearable
                  options={SALES_PEOPLE}
                  value={selectedSalesPerson}
                  onChange={(selected) => this.handleSelect(SALES_PERSON, selected)}
                  onInputChange={(input) => this.handleInput(SALES_PERSON, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'email'}
                  valueKey={'id'}
                />
                <div>Prescriber</div>
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingPrescribers}
                  options={prescribers}
                  value={selectedPrescriber}
                  onChange={(selected) => this.handleSelect(PRESCRIBER, selected)}
                  onInputChange={(input) => this.handleInput(PRESCRIBER, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'name'}
                  valueKey={'id'}
                />
              </div>
            }
          </Step>
          {
            (selectedSite || selectedPrescriber || selectedSalesPerson) && !isFetchingPrescribers
            ? _.map(prescribers, (prescriber) => {
              if (selectedPrescriber && prescriber.id !== selectedPrescriber.id) return null
              return (
                <div key={`${prescriber.first_name}-${prescriber.id}`}>
                  <EditPrescriberView
                    prescriber={prescriber}
                    updatePrescriber={updatePrescriber}
                    isUpdatingPrescriber={isUpdatingPrescriber}
                    isUploadingSignature={isUploadingSignature}
                  />
                </div>
              )
            })
            : null
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/PrescriberVerificationView.jsx